import React from 'react';
export function ConnectionInsert() {
  return <section className="py-12 px-5" data-id="element-62">
      <div className="max-w-lg mx-auto" data-id="element-63">
        <div className="flex flex-col-reverse md:flex-row gap-6 items-center" data-id="element-64">
          {/* Text block — left on desktop, below on mobile */}
          <div className="w-full md:w-1/2" data-id="element-65">
            <h3 className="font-serif text-2xl md:text-3xl text-white leading-snug mb-4 italic" data-id="element-66">
              Libertad en ambos extremos de la correa.
            </h3>
            <p className="text-white/70 leading-relaxed" data-id="element-67">
              Cuando el estrés desaparece, aparece la conexión. Siente la
              ligereza de una correa que ya no necesita fuerza para comunicar.
            </p>
          </div>

          {/* Image — clean, no filters */}
          <div className="w-full md:w-1/2 flex-shrink-0" data-id="element-68">
            <img src="https://cdn.magicpatterns.com/uploads/gdMLDsdtn11Ki66SS4YsfS/imagenlanding_2.png" alt="Correa suelta en sonrisa" className="w-full h-auto rounded-xl object-cover" data-id="element-69" />
          </div>
        </div>
      </div>
    </section>;
}